export default __webpack_public_path__ + "static/media/WeChat.cac8347b.png";